<div [class.loader-overlay]="calssName.length == 0" class="{{calssName}}" id="barsLoader">
        <div class="{{calssName == 'deliveryPickup-loader' ? 'inline-loders' : 'loader-content'}}">
            <div class="bars-loader">
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
            </div>
            <div class="loader-text">Syncing Data</div>
            <div class="loader-subtext">Updating latest information</div>
        </div>
    </div>